<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" data-dismiss="modal" (click)="bsModalRef.close()">×</button>
  </div>
  <div class="modal-body">
    <div>
      <div>{{message}}</div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-md-inline-block w-100">
      <button type="button" class="btn btn-primary btn-xs float-right" (click)="close()">Close</button>
    </div>
  </div>
